import React, {Component} from 'react';

import '../../sass/faqitem.scss';

class FaqQuestion extends Component
{
    constructor(props) {
        super(props);
        this.state = {
            show: false
        }
    }
    toggleShow() {
        (this.state.show) ? this.setState({show: false}) : this.setState({show: true});
    }
    render()
    {
        const { data } = this.props;
        const {show} = this.state;
        let nameClass = 'header-item';
        if (show) nameClass = 'header-item active';

        return (
            <div className="content-item">
                <div className={nameClass} onClick={(e)=>{this.toggleShow()}}>
                    <p>{data.question}</p>
                </div>
                <div className="text">
                    {data.answer}
                </div>
            </div>
        )
    }
}

export default FaqQuestion;







// WEBPACK FOOTER //
// ./src/components/faq/FaqQuestion.js